import { Suspense } from "react";
import LoaderScreen from "../common/LoaderScreen";
import Booking from "../components/Booking";
import UserCollection from "../components/Reports/UserCollection";
import AgentTicket from "../components/Reports/AgentTicket";
import { Terms } from "../components/Terms";
import { PrivacyPolicy } from "../components/PrivacyPolicy";
import AgentTransactions from "../components/Reports/AgentTxn";
import InquiryOneReport from "../components/Booking/RightSection/InquiryOneReport";
import InquiryTwoReport from "../components/Booking/RightSection/InquiryTwoReport";

export const routeList = [
    {
        path: "/", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <Booking />
                </Suspense>
            )
    },
    {
        path: "/userCollectionReport", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <UserCollection />
                </Suspense>
            )
    },
    {
        path: "/agentTicketReport", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <AgentTicket />
                </Suspense>

            )
    },
    {
        path: "/agentTxnsReport", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <AgentTransactions />
                </Suspense>
            )
    },
    {
        path: "/inquriyOneReport", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <InquiryOneReport />
                </Suspense>
            )
    },
    {
        path: "/inquriyTwoReport", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <InquiryTwoReport />
                </Suspense>
            )
    }


]

export const publicRoutes = [
    {
        path: "/terms_of_use", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <Terms />
                </Suspense>

            )
    },
    {
        path: "/privacy_policy", element:
            (
                <Suspense fallback={<LoaderScreen />}>
                    <PrivacyPolicy />
                </Suspense>

            )
    },
]